
import { Component, Vue } from "vue-property-decorator";
import Pagination from "@/components/Pagination/index.vue";
import { ICustomerModel } from "@/api/types";
import { Message } from "element-ui";
import { defaultCustomerData } from "@/api/customer";
import ContainerTypeReleasedInfo from "@/views/components/ContainerTypeReleasedInfo.vue";
import {
  getCustomerInfoAndCompany,
  getShippingOrderByCustomerIdAndNoReleasedToBookingOrder,
} from "@/api/shipping-order";
import FactoryLoadingPlanHqPackingListInfoTable from "@/views/components/FactoryLoadingPlanHqPackingListInfoTable.vue";
import { ShippingOrderModel } from "@/model/shipping-order";
import { exportJson2Excel } from "@/utils/excel";
import { formatJson } from "@/utils";
import {
  BookingOrderProcessStage,
  DeclarationState,
} from "@/model/booking-order";
import {
  CURRENCY_UNIT,
  INTERNATIONAL_TRADE_TERMS,
  LADING_TYPE,
  PAYMENT_TYPE,
} from "@/constant";
import {
  confirmReceipt,
  createBookingOrder,
  declare,
  getLoadingPlanListDetail,
  listProcessStages,
  invoiceProducts,
  queryDeclarationInfo,
  searchBookingOrderForFinancial,
  updateBookingOrder,
  updateDeadlineDate,
  updateDeclarationInfo,
  updateSailingSchedule,
  getExcelUrl,
  deleteBookingOrder,
  getCustomerOtherInfo,
  uploadDocuments,
  getDocumentsList,
  updateRemark,
  deleteQingGuanList,
} from "@/api/booking-order";
import ContainerLoadingInfoComponent, {
  ContainerLoadingInfoData,
  LoadingPlanInfo,
} from "@/views/components/ContainerLoadingInfoComponent.vue";
import { CustomsPackingModel } from "@/model/HenganLoadingPlanModels";
import { isEmpty } from "lodash";
import { upload } from "@/api/upload";
import * as querystring from "querystring";
import { checkAccount } from "@/directives";
import Template from "@/views/system-management/template/index.vue";
import UpdateMark from "@/views/customs-management/edit/mark.vue";
import {Mark} from "@/views/customs-management/edit/mark.vue";
import {queryMarkLetter} from "@/api/purchase-order";
import SingleSelect from "@/views/customs-management/edit/singleSelect.vue";

@Component({
  name: "SalesBookingOrderManagement",
  components: {
    SingleSelect,
    UpdateMark,
    Template,
    ContainerLoadingInfoComponent,
    FactoryLoadingPlanHqPackingListInfoTable,
    ContainerTypeReleasedInfo,
    Pagination,
    GenerateIV: () => import("./components/GenerateIV.vue"),
    AddDeclarationDocumentDialog: () =>
      import("./components/AddDeclarationDocumentDialog.vue"),
  },
  methods: {
    checkAccount,
    querystring() {
      return querystring;
    },
    PAYMENT_TYPE,
    INTERNATIONAL_TRADE_TERMS,
    LADING_TYPE,
    CURRENCY_UNIT,
  },
})
export default class extends Vue {
  private tableKey = 0;
  private total = 0;
  private listLoading = false;
  private writeBookingOrderDialogVisible = false;
  private generateIVDialogVisible = false;
  private popoverVisible = false;
  private ivAccountType = "A";
  private rules = {
    companyCode: [{ required: true, message: "请选择公司", trigger: "blur" }],
    code: [{ required: true, message: "请输入报关合同号", trigger: "blur" }],
    customerId: [{ required: true, message: "请选择客户", trigger: "blur" }],
    shippingOrderId: [
      { required: true, message: "请选择订舱单", trigger: "blur" },
    ],
    currency: [{ required: true, message: "请选择结算货币", trigger: "blur" }],
    blCompanyName: [
      { required: true, message: "请选择BL公司名", trigger: "blur" },
    ],
    blCompanyAddress: [
      { required: true, message: "请选择BL公司地址", trigger: "blur" },
    ],
    ivCompanyName: [
      { required: true, message: "请选择IV公司名称", trigger: "blur" },
    ],
    ivCompanyAddress: [
      { required: true, message: "请选择IV公司地址", trigger: "blur" },
    ],
    fivePiecesSetCompanyName: [
      { required: true, message: "请选择五件套公司名称", trigger: "blur" },
    ],
    fivePiecesSetCompanyAddress: [
      { required: true, message: "请选择五件套公司地址", trigger: "blur" },
    ],
  };
  private table = {
    total: 0,
    pageNumber: 1,
    pageSize: 20,
    list: [] as any,
  };
  public tableCol = [
    {
      label: "文件名",
      prop: "fileName",
      key: "fileName",
      show: true,
      disabled: false,
      fixed: true,
    },
    {
      label: "上传日期",
      prop: "createdTime",
      key: "createdTime",
      type: "datetime",
      show: true,
      disabled: false,
      fixed: true,
    },
    {
      label: "备注",
      prop: "remark",
      key: "remark",
      type: "remark",
      show: true,
      disabled: false,
      fixed: true,
    },
  ];
  private listQuery = {
    pageNumber: 1,
    pageSize: 20,
    code: null,
    startDate: null,
    endDate: null,
    customerKeyword: null,
    stage: null,
    receiptState: null,
    dateRange: null,
    processStage: null,
    saleName: null,
  };
  // 下载列表弹窗选中的rows
  public diologROW = {} as any;
  public selectRows = [] as any;
  private filesPL = [];
  private showFileList = false;
  private QingGuanZiLiaoShow = false;
  private bookingOrders:any = [];
  private currentRow: BookingOrderTableRowData = new BookingOrderTableRowData();
  private writeBookingOrderRequest: WriteBookingOrderRequest =
    new WriteBookingOrderRequest();
  private processStages: BookingOrderProcessStage[] = [];
  private customerOtherInfos = [];
  private generateIVRequest = {};

  private clickROW = { id: "" };

  created() {
    if(this.$route.query.code) {
      this.listQuery.code = this.$route.query.code;
    } else if(this.$route.params.code) {
      this.listQuery.code = this.$route.params.code;
    }
    this.initProcessStages();
    this.getList();
  }

  private async getCustomerInfo(shippingOrderId: string) {
    if (shippingOrderId) {
      const data: any = await getCustomerInfoAndCompany(shippingOrderId);
      this.writeBookingOrderRequest.companyDesc = data.company.desc;
      this.writeBookingOrderRequest.companyCode = data.company.name;
      this.writeBookingOrderRequest.customerId = data.customerId;
      this.writeBookingOrderRequest.abbreviation = data.abbreviation;
      this.writeBookingOrderRequest.blCompanyName = data.blCompanyName;
      this.writeBookingOrderRequest.blCompanyAddress = data.blCompanyAddress;
      this.writeBookingOrderRequest.blOtherInfo = data.blCompanyInfo;
      this.writeBookingOrderRequest.ivCompanyName = data.ivCompanyName;
      this.writeBookingOrderRequest.ivCompanyAddress = data.ivCompanyAddress;
      this.writeBookingOrderRequest.ivCompanyOtherInfo = data.ivCompanyInfo;
      this.writeBookingOrderRequest.fivePiecesSetCompanyName =
        data.fivePiecesSetCompanyName;
      this.writeBookingOrderRequest.fivePiecesSetCompanyAddress =
        data.fivePiecesSetCompanyAddress;
      this.writeBookingOrderRequest.fivePiecesSetCompanyOtherInfo =
        data.fivePiecesSetCompanyOtherInfo;
      this.writeBookingOrderRequest.notifier = data.notifier;
      this.writeBookingOrderRequest.notifierAddress = data.notifierAddress;
      this.writeBookingOrderRequest.blNotifyPersonInfo =
        data.blNotifyPersonInfo;
      this.writeBookingOrderRequest.internationalTradeTerms =
        data.internationalTradeTerms;
      this.writeBookingOrderRequest.ivCompanyNames = data.ivCompanyNames;
      this.writeBookingOrderRequest.ivCompanyAddresses = data.ivCompanyAddresses;
      this.writeBookingOrderRequest.ivCompanyInfos = data.ivCompanyInfos;
    }
  }

  private getHiddenColumnsAsValue(value: string) {
    if (
      this.$route.meta.buttonCodes &&
      Array.isArray(this.$route.meta.buttonCodes)
    ) {
      return this.$route.meta.buttonCodes.includes(value);
    }
  }
  public async handleRemark(item) {
    let params = {
      remark: item.remark,
    };
    await updateRemark(item.documentId, params);
    this.$notify({
      title: "成功",
      message: "修改成功",
      type: "success",
      duration: 2000,
    });
  }

  private handleFilter() {
    this.listQuery.pageNumber = 1;
    this.getList();
  }

  private customers: ICustomerModel[] = [];

  private isLoadingShippingOrders = false;
  private shippingOrders: ShippingOrderModel[] = [];

  private getCustomerShippingOrders(a) {
    this.isLoadingShippingOrders = true;
    getShippingOrderByCustomerIdAndNoReleasedToBookingOrder({
      shippingOrderCodeKeyWord: a,
    }).then((res: any) => {
      this.shippingOrders = res;
      this.isLoadingShippingOrders = false;
    });
  }

  private showWriteBookingOrderDialog(row: BookingOrderTableRowData) {
    this.initCompanyTypes();
    this.writeBookingOrderRequest = new WriteBookingOrderRequest();
    if (row) {
      this.currentRow = row;
      this.writeBookingOrderRequest.companyCode = row.companyCode;
      this.writeBookingOrderRequest.companyDesc =
        row.companyCode === "HQ" ? "华强" : "嘉锐";
      this.writeBookingOrderRequest.id = row.id;
      this.writeBookingOrderRequest.code = row.code;
      this.writeBookingOrderRequest.customerId = row.customerId;
      this.writeBookingOrderRequest.currencyUnit = row.currencyUnit;
      this.writeBookingOrderRequest.shippingOrderId = row.shippingOrderId;
      this.writeBookingOrderRequest.forwardingCompanies =
        row.forwardingCompanies;
      const customer = defaultCustomerData;
      customer.id = row.customerId;
      customer.abbreviation = row.customerAbbr;
      this.customers = [customer];
      const shippingOrder = new ShippingOrderModel();
      shippingOrder.id = row.shippingOrderId;
      shippingOrder.shippingCode = row.shippingOrderCode;
      this.shippingOrders = [shippingOrder];
      this.writeBookingOrderRequest.abbreviation = row.customerAbbr;
      this.writeBookingOrderRequest.blCompanyName = row.blCompanyName;
      this.writeBookingOrderRequest.blCompanyAddress = row.blCompanyAddress;
      this.writeBookingOrderRequest.blOtherInfo = row.blOtherInfo;
      this.writeBookingOrderRequest.ivCompanyName = row.ivCompanyName;
      this.writeBookingOrderRequest.ivCompanyAddress = row.ivCompanyAddress;
      this.writeBookingOrderRequest.ivCompanyOtherInfo = row.ivCompanyInfo;
      this.writeBookingOrderRequest.fivePiecesSetCompanyName =
        row.fivePiecesSetCompanyName;
      this.writeBookingOrderRequest.fivePiecesSetCompanyAddress =
        row.fivePiecesSetCompanyAddress;
      this.writeBookingOrderRequest.fivePiecesSetCompanyOtherInfo =
        row.fivePiecesSetCompanyOtherInfo;
      this.writeBookingOrderRequest.notifier = row.notifier;
      this.writeBookingOrderRequest.notifierAddress = row.notifierAddress;
      this.writeBookingOrderRequest.blNotifyPersonInfo = row.blNotifyPersonInfo;
      this.writeBookingOrderRequest.internationalTradeTerms = row.internationalTradeTerms;
      this.writeBookingOrderRequest.freightAmount = row.freightAmount;
      this.writeBookingOrderRequest.insuranceAmount = row.insuranceAmount;
      this.writeBookingOrderRequest.extrasAmount = row.extrasAmount;
      this.updateIvInfo(shippingOrder.id).then(()=>{
      this.writeBookingOrderDialogVisible = true;
      });
    } else {
      this.currentRow = new BookingOrderTableRowData();
      this.writeBookingOrderDialogVisible = true;
    }
  }

  private async updateIvInfo(shippingOrderId: string) {
    const data: any = await getCustomerInfoAndCompany(shippingOrderId);
    this.writeBookingOrderRequest.ivCompanyNames = data.ivCompanyNames;
    this.writeBookingOrderRequest.ivCompanyAddresses = data.ivCompanyAddresses;
    this.writeBookingOrderRequest.ivCompanyInfos = data.ivCompanyInfos;
  }

  private async handleWriteBookingOrder() {
    const loading = this.$loading({
      lock: true,
      text: 'Loading',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    });
    if (this.writeBookingOrderRequest.id) {
      await updateBookingOrder(
        this.writeBookingOrderRequest.id,
        this.writeBookingOrderRequest
      ).then(async res => {
        this.writeBookingOrderDialogVisible = false;
        await this.getList();
        loading.close();
      }).catch(err => {
        console.log(err);
        loading.close();
      });
    } else {
      await createBookingOrder(this.writeBookingOrderRequest).then(async res => {
        this.writeBookingOrderDialogVisible = false;
        await this.getList();
        loading.close();
      }).catch(err => {
        console.log(err);
        loading.close();
      });
    }
  }

  private checkPermission(value) {
    return this.$route.meta.buttonCodes.includes(value)
  }

  // 生成IV
  private async showGenerateIV(row: BookingOrderTableRowData) {
    this.currentRow = row;
    this.ivAccountType = "B";
    this.generateIVDialogVisible = true;
  }

  private async handleGenerateIV() {
    this.generateIVDialogVisible = false;
    await this.getList();
  }

  private async handleEditDeadlineDate(row: BookingOrderTableRowData) {
    if (!row.newDeadlineDate) {
      Message.error({ message: "请选择日期", duration: 2000 });
      return;
    }
    await updateDeadlineDate(row.id, row.newDeadlineDate);
    row.isEditDeadlineDatePopoverVisible = false;
    row.newDeadlineDate = null;
    await this.getList();
  }

  private async handleEditSailingSchedule(row: BookingOrderTableRowData) {
    if (!row.newSailingSchedule) {
      Message.error({ message: "请选择日期", duration: 2000 });
      return;
    }
    await updateSailingSchedule(row.id, row.newSailingSchedule);
    row.isEditSailingSchedulePopoverVisible = false;
    row.newSailingSchedule = null;
    await this.getList();
  }

  private onCustomerSelectionChange() {
    this.writeBookingOrderRequest.shippingOrderId = null;
  }

  private async getList() {
    this.listLoading = true;
    if (this.listQuery.dateRange) {
      this.listQuery.startDate = this.listQuery.dateRange[0];
      this.listQuery.endDate = this.listQuery.dateRange[1];
    }
    const params = { ...this.listQuery,type:"SALE_PAGE" };
    params.dateRange = null;
    const { content, total }: any = await searchBookingOrderForFinancial(
      params
    );
    this.bookingOrders = content.map((value) => {
      const rowData: BookingOrderTableRowData = new BookingOrderTableRowData();
      Object.assign(rowData, value);
      return rowData;
    });
    this.bookingOrders.map((item,index) => {item.sn = index + 1})
    this.total = total;
    this.listLoading = false;
  }

  private companyTypes: CompanyType[] = [];

  private initCompanyTypes() {
    this.companyTypes = [];
    this.companyTypes.push(new CompanyType("SELF", "自拉自报"));
    this.companyTypes.push(new CompanyType("APPOINTED", "指定货代"));
    this.companyTypes.push(new CompanyType("OTHER", "其他类型"));
  }

  private async initProcessStages() {
    const data: any = await listProcessStages();
    this.processStages = data;
  }

  private async deleteBookingOrder(id: string) {
    await deleteBookingOrder(id);
    this.$message({
      type: "success",
      message: "操作成功!",
    });
    await this.getList();
  }

  // 确认报关信息
  private confirmDeclarationInfoDialogVisible = false;
  private declarationInfo: DeclarationInfo = new DeclarationInfo(
    defaultCustomerData,
    new DeclarationCharge(),
    "",
    "",
    ""
  );

  private async showConfirmDeclarationInfoDialog(
    row: BookingOrderTableRowData
  ) {
    this.currentRow = row;
    this.confirmDeclarationInfoDialogVisible = true;
    const {
      customer,
      declarationCharge,
      invoiceMoney,
      shippingMark,
      currencyUnit,
    }: any = await queryDeclarationInfo(row.id);
    this.declarationInfo = new DeclarationInfo(
      customer,
      declarationCharge || new DeclarationCharge(),
      invoiceMoney,
      shippingMark,
      currencyUnit
    );
    const marks:string[] = shippingMark.split('；');
    this.markInput = marks;
     const data: any = await queryMarkLetter([], this.currentRow.customerId)
    this.markLetters = data.map((item) => new Mark(item,false));
    this.getInsuranceAmount(this.currentRow.useInvoiceMoney);
  }
  private clearMarkLetters():boolean {
    const marks: string[] = this.declarationInfo.shippingMark.split('；');
    this.markInput = marks;
    return true;
  }

  private async handleConfirmDeclarationInfo(confirm: boolean) {
    const paymentType = this.declarationInfo.customer.payment;
    if (
      (paymentType === "CIF" || paymentType === "C&F") &&
      !this.declarationInfo.declarationCharge.freightAmount
    ) {
      return Message.error({ message: "请填写运费" });
    }
    await updateDeclarationInfo(this.currentRow.id, {
      confirm,
      ...this.declarationInfo.customer,
      ...this.declarationInfo.declarationCharge,
      shippingMark: this.markInput.join('；'),
      currencyUnit: this.declarationInfo.currencyUnit,
    });
    this.confirmDeclarationInfoDialogVisible = false;
    await this.getList();
  }

  // 添加报关单据
  private addLoadingPlanListDialogVisible = false;

  private showAddDeclarationDocumentDialog(row: BookingOrderTableRowData) {
    this.currentRow = row;
    this.addLoadingPlanListDialogVisible = true;
  }

  //查看报关单据详情
  private checkLoadingPlanListDetailDialogVisible = false;
  private loadingPlanListDetail: LoadingPlanListDetailResponse =
    new LoadingPlanListDetailResponse();
  private containerLoadingInfos: ContainerLoadingInfoData[] = [];

  private checkLoadingPlanListDetail(row: BookingOrderTableRowData) {
    this.checkLoadingPlanListDetailDialogVisible = true;
    this.currentRow = row;
    this.queryLoadingPlanListDetail(this.currentRow.loadingPlanListId);
  }

  private gotoDocumentFlow(data) {
    this.$router.push({
      name: "DocumentFlow",
      params: { type: "BOOKING_ORDER", documentId: data.id },
    });
  }

  // 保费
  private internationalTradeTerms(useInvoiceMoney: boolean) {
    const charge = new DeclarationCharge();
    charge.id = this.declarationInfo.declarationCharge.id;
    charge.bookingOrderId =
      this.declarationInfo.declarationCharge.bookingOrderId;
    charge.freightAmount = "0.00";
    charge.extrasAmount = "0.00";
    charge.insuranceAmount = "0.000";
    if (this.declarationInfo.customer.internationalTradeTerms === "2") {
      let amount = Number(this.declarationInfo.invoiceMoney);
      amount = amount * 1.1 * 0.001;
      charge.insuranceAmount = amount.toFixed(4);
    }
    this.declarationInfo.declarationCharge = charge;
  }

  private getInsuranceAmount(useInvoiceMoney: boolean) {
    if (this.declarationInfo.customer.internationalTradeTerms === "2") {
      let amount = Number(this.declarationInfo.invoiceMoney);
      amount = amount * 1.1 * 0.001;
      this.declarationInfo.declarationCharge.insuranceAmount =
        amount.toFixed(4);
    }
  }

  private async queryLoadingPlanListDetail(loadingPlanListId: string) {
    const data: any = await getLoadingPlanListDetail(loadingPlanListId);
    this.loadingPlanListDetail = data;
    this.containerLoadingInfos = data.loadingInfos.map((value) => {
      const containerLoadingInfo: ContainerLoadingInfoData = { ...value };
      containerLoadingInfo.type = value.loadingPlanType;
      containerLoadingInfo.loadingPlans = value.loadingPlans.map(
        (loadingPlan) => {
          const loadingPlanInfo = new LoadingPlanInfo();
          loadingPlanInfo.id = loadingPlan.id;
          loadingPlanInfo.type = loadingPlan.loadingPlanType;
          loadingPlanInfo.code = loadingPlan.loadingPlanCode;
          loadingPlanInfo.customsPackingInfos = loadingPlan.customsPackingSet;
          return loadingPlanInfo;
        }
      );
      return containerLoadingInfo;
    });
  }

  // 确认收款
  private async handleConfirmReceipt(row: BookingOrderTableRowData) {
    if (!row.receiptDate) {
      Message.error({ message: "请选择日期", duration: 2000 });
      return;
    }
    await confirmReceipt(row.id, row.receiptDate);
    row.isConfirmReceiptPopoverVisible = false;
    await this.getList();
  }

  // 报关
  private async handleDeclare(row: BookingOrderTableRowData) {
    await declare(row.id);
    await this.getList();
  }

  // 客户IV
  private files: File[] = [];
  public filesDOC: File[] = [];

  private async requestUploadInvoice(row: BookingOrderTableRowData) {
    await this.openUseInvoiceMoney(row);
  }

  // 查看IV
  private async checkInvoice(row: BookingOrderTableRowData) {
    // empty
  }

  private async uploadInvoice(row: BookingOrderTableRowData) {
    const formData = new FormData();
    formData.append("file", this.files.pop());
    await upload(
      `/booking-orders/${this.currentRow.id}/invoice-money`,
      formData
    );
  }

  private addFile(file: File) {
    // this.files = [file];
    this.files.push(file);
  }

  private addFilesPL(file: File) {
    // this.files = [file];
    this.filesPL.push(file);
  }

  // 导出excel
  private exportExcel() {
    const data = this.bookingOrders.map((value) => {
      return {
        stateDesc: value.declarationState && value.declarationState.desc,
        stageDesc: value.processStage && value.processStage.desc,
        forwardingCompanyNames: value.forwardingCompanyNames.join(","),
        ...value,
      };
    });
    const headers = [
      "报关合同号",
      "截单日期",
      "船期",
      "货代",
      "订舱号",
      "客户收款时间",
      "报关状态",
      "客户简称",
      "结算货币",
      "处理阶段",
      "产品数量",
      "IV金额",
    ];
    const fieldNames = [
      "code",
      "deadlineDate",
      "sailingSchedule",
      "forwardingCompanyNames",
      "shippingOrderCode",
      "",
      "stateDesc",
      "customerAbbr",
      "currencyUnit",
      "stageDesc",
      "productQuantity",
      "totalInvoiceMoney",
    ];
    exportJson2Excel(
      headers,
      formatJson(fieldNames, data),
      `报关合同（销售）-${new Date()}`
    );
  }

  //  是否选择使用发票金额作为报关金额
  private openUseInvoiceMoney(row: BookingOrderTableRowData) {
    this.$confirm("是否选择使用发票金额作为报关金额", "提示", {
      confirmButtonText: "是",
      cancelButtonText: "否",
      type: "warning",
      distinguishCancelAndClose: true,
    })
      .then(() => {
        this.confirmUseInvoiceMoney(row, true);
      })
      .catch((action) => {
        if (action === "cancel") {
          this.confirmUseInvoiceMoney(row, false);
        } else {
        }
      });
  }

  // 确认选择
  private async confirmUseInvoiceMoney(
    row: BookingOrderTableRowData,
    confirm: boolean
  ) {
    const formData = new FormData();
    formData.append("file", this.files.pop());
    await upload(
      `/booking-orders/${this.currentRow.id}/invoice-money?useInvoiceMoney=${confirm}`,
      formData
    );
    this.$message({
      type: "success",
      message: "操作成功!",
    });
    await this.getList();
  }

  // 下载
  private async downloadInvoice(row: BookingOrderTableRowData, accountType: string) {
    await getExcelUrl(row.id, accountType);
    // console.log('resresresresresresres',res)
    // doDownload(res);
  }

  /**
   * 下载客户IV模版
   */
  private async downloadInvoiceTemplate(row: BookingOrderTableRowData) {
    const res: any = await invoiceProducts(row.id);
    const { bookingOrderCode, customerAbbr, products } = res;
    let totalNumber = 0;
    products.map((item, index) => {
      item.index = index + 1;
      totalNumber = item.totalNumberPcs + totalNumber;
    });
    const t1 = [
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "TOTAL QTY",
      "",
      `${totalNumber}`,
      "",
    ];
    const t2 = ["", "", "", "", "", "", "", "TOTAL AMOUNT", "", "0", ""];
    const header0 = [
      "",
      "客户简称",
      customerAbbr,
      "报关合同号",
      bookingOrderCode,
      "",
      "",
      "IV号码",
      "",
      bookingOrderCode.replace("BSC", "IV"),
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
    ];
    const header1 = [
      "S/N",
      "华强品名",
      "客户号码",
      "华强号码",
      "OE号码",
      "参照号码",
      "QTY",
      "UNIT PRICE",
      "TOTAL SUM",
      "",
      "",
      "",
      "号码变更（如有需要填写）",
      "",
      "",
      "",
      "客人的其他信息（选填）",
      "",
      "",
      "",
      "",
      "",
    ];
    const header2 = [
      "",
      "H&Q Product Name",
      "Customer No.",
      "H&Q No.",
      "OE No.",
      "REF No.",
      "PCS",
      "",
      "",
      "PO",
      "报关品名",
      "采购订单号",
      "订单批次",
      "Customer No.",
      "H&Q No.",
      "OE No.",
      "REF No.",
      "内盒尺寸",
      "内盒型号",
      "BRAND",
      "其他信息",
      "其他信息",
      "其他信息",
      "其他信息",
    ];
    if (products.length) {
      products.push({
        index: "",
        description: "",
        guestModel: "",
        hqOrJrNumber: "TOTAL",
        oeNumber: "",
        refNumber: "",
        totalNumberPcs: totalNumber,
        unit_price: "",
        total_sum: "0.00",
        poNumber: "",
        declarationDescription: "",
        purchaseOrderNumber: "",
        batch: "",
      });
    }
    const fieldNames = [
      "index",
      "description",
      "guestModel",
      "hqOrJrNumber",
      "oeNumber",
      "refNumber",
      "totalNumberPcs",
      "unit_price",
      "total_sum",
      "poNumber",
      "declarationDescription",
      "purchaseOrderNumber",
      "batch",
    ];
    const merges = [
      "A4:A5",
      "H4:H5",
      "H1:I1",
      "H2:I2",
      "I4:I5",
      "M4:P4",
      "Q4:W4",
    ];
    const filename = `IV模版-${row.customerAbbr}-${row.code}`;
    exportJson2Excel(
      t1,
      formatJson(fieldNames, products),
      filename,
      [t2, header0, header1, header2],
      merges,
      false
    );
  }

  private canCheckDetail(row: BookingOrderTableRowData) {
    return !isEmpty(row.loadingPlanListId);
  }

  private canUploadInvoice(row: BookingOrderTableRowData) {
    return row.processStage.canUploadInvoice;
  }

  // 是否可以重新上传
  private canReUploadInvoice(row: BookingOrderTableRowData) {
    return row.processStage.canReUploadInvoice;
  }

  private canCheckInvoice(row: BookingOrderTableRowData) {
    return row.processStage.canCheckInvoice;
  }

  private canDownloadInvoice(row: BookingOrderTableRowData, type: string) {
    if (type === "A") {
      return row.processStage.canDownloadInvoiceA;
    }
    if (type === "B") {
      return row.processStage.canDownloadInvoiceB;
    }
  }

  private canAddLoadingPlanList(row: BookingOrderTableRowData) {
    return (
      row.processStage &&
      row.processStage.name === "CREATED" &&
      isEmpty(row.loadingPlanListId)
    );
  }

  private canUpdateLoadingPlanList(row: BookingOrderTableRowData) {
    return (
      row.processStage &&
      row.processStage.name === "CREATED" &&
      !isEmpty(row.loadingPlanListId)
    );
  }

  private canUpdateBookingOrder(row: BookingOrderTableRowData) {
    return row.processStage && row.processStage.name === "CREATED";
  }

  private canConfirmDeclarationInfo(row: BookingOrderTableRowData) {
    return row.processStage && row.processStage.canConfirmDeclarationInfo;
  }

  private canDeleteBookingOrder(row: BookingOrderTableRowData) {
    return row.processStage && row.processStage.canDeleteBookingOrder;
  }

  private canUpdateDeclarationInfo(row: BookingOrderTableRowData) {
    return (
      row.processStage && row.processStage.name === "CUSTOMER_INVOICE_UPLOADED"
    );
  }

  private canDownloadInvoiceTemplate(row: BookingOrderTableRowData) {
    return row.processStage && row.processStage.canDownloadInvoiceTemplate;
  }

  private getUseInvoiceTest(row: BookingOrderTableRowData) {
    if (row.useInvoiceMoney && row.processStage.canDownloadInvoiceA) {
      return "查看金额";
    } else if (!row.useInvoiceMoney && row.processStage.canDownloadInvoiceA) {
      return "查看金额";
    }
    return "无金额";
  }

  private async getOtherInfo(querySearch, cb, group: string) {
    if (querySearch) {
      if (this.writeBookingOrderRequest.customerId) {
        const data: any = await getCustomerOtherInfo(
          this.writeBookingOrderRequest.customerId,
          querySearch,
          group
        );
        // 转换结构。cb接收的是{value: ""} 这样的结构
        let array: string[] = data;
        let newArray = array.map((x) => {
          return { value: x };
        });
        cb(newArray);
      } else {
        cb([]);
      }
    }
  }

  private clearFocus() {
    const clearFocus: any = document.activeElement;
    clearFocus.blur();
  }

  private onSelectionChange(rows) {
    this.selectRows = [];
    this.selectRows = rows;
  }

  private renderCusAbbr(prop, row) {
    if (row.pcNames && row.pcNames.length > 0){
      return `[${row.pcNames}]${prop}`
    }
    return prop
  }

  private showMarkEdit = false;

  private showMarkEditDialog() {
    this.showMarkEdit = true;
  }

  private markLetters: Mark[] = [];
  private markInput: string[] = [];

  private handleEditMarkSuccess(marks: Mark[]) {
    this.markInput = marks.map(item => item.value);
    this.showMarkEdit = false;
  }

  private addRemarkDialogVisible = false;

  private listRemark = {
    bookingOrderId: null,
    remark: null
  };

  private showAddRemarkDialog(row) {
    this.listRemark = {
      bookingOrderId: row.id,
      remark: row.remark
    };
    this.addRemarkDialogVisible = true;
  }

  private async doAddRemark() {
    await updateBookingOrder(
        this.listRemark.bookingOrderId, {
          remark: this.listRemark.remark,
          type: "SALE_PAGE"
        }
    );
    this.addRemarkDialogVisible = false;
    await this.getList();
  }

   private handlerSelected(selected:string,type:string) {
    this.writeBookingOrderRequest[type] = selected;
  }

  private clearAmount() {
    this.writeBookingOrderRequest.freightAmount = null;
    this.writeBookingOrderRequest.insuranceAmount = null;
    this.writeBookingOrderRequest.extrasAmount = null;
  }
}

class BookingOrderTableRowData {
  id: string;
  code: string;
  companyCode: string;
  customerAbbr: string;
  customerId: string;
  shippingOrderId: string;
  shippingOrderCode: string;
  currencyUnit: string;
  receiptDate: string;
  deadlineDate: string;
  sailingSchedule: string;
  invoiceId: string;
  invoiceCode: string;
  useInvoiceMoney: boolean;
  invoiceMoney: string;
  loadingPlanListId: string;
  declarationState: DeclarationState;
  processStage: BookingOrderProcessStage;
  forwardingCompanies: Company[];
  blCompanyName: string;
  blCompanyAddress: string;
  blOtherInfo: string;
  ivCompanyName: string;
  ivCompanyAddress: string;
  ivCompanyInfo: string;
  fivePiecesSetCompanyName: string;
  fivePiecesSetCompanyAddress: string;
  fivePiecesSetCompanyOtherInfo: string;
  notifier: string;
  notifierAddress: string;
  blNotifyPersonInfo: string;

  //for edit
  newDeadlineDate: string;
  newSailingSchedule: string;
  isEditDeadlineDatePopoverVisible = false;
  isEditSailingSchedulePopoverVisible = false;
  isConfirmReceiptPopoverVisible = false;
  popoverVisible = false;
  popoverInvoiceVisible = false;
  internationalTradeTerms:string;
  freightAmount:string; // 运费
  insuranceAmount:string; //保费
  extrasAmount:string; //杂费
}

class DeclarationInfo {
  invoiceMoney: string;
  customer: ICustomerModel;
  declarationCharge: DeclarationCharge;
  shippingMark: string;
  currencyUnit: string;

  constructor(
    customer: ICustomerModel,
    declarationCharge: DeclarationCharge,
    invoiceMoney: string,
    shippingMark: string,
    currencyUnit: string
  ) {
    this.customer = customer;
    this.declarationCharge = declarationCharge;
    this.invoiceMoney = invoiceMoney;
    this.shippingMark = shippingMark;
    this.currencyUnit = currencyUnit;
  }
}

class DeclarationCharge {
  id: string;
  bookingOrderId: string;
  freightAmount: string;
  insuranceAmount: string;
  extrasAmount: string;
}

class WriteBookingOrderRequest {
  id: string = null;
  code: string = null;
  companyCode: string = null;
  customerId: string = null;
  shippingOrderId: string = null;
  currencyUnit: string = null;
  forwardingCompanies: Company[] = [];
  companyDesc: string = null;
  abbreviation: string = null;
  blCompanyName: string = null;
  blCompanyAddress: string = null;
  blOtherInfo: string = null;
  ivCompanyName: string = null;
  ivCompanyAddress: string = null;
  ivCompanyOtherInfo: string = null;
  fivePiecesSetCompanyName: string = null;
  fivePiecesSetCompanyAddress: string = null;
  fivePiecesSetCompanyOtherInfo: string = null;
  notifier: string = null;
  notifierAddress: string = null;
  blNotifyPersonInfo: string = null;
  internationalTradeTerms: string = null;
  freightAmount: string = null;
  insuranceAmount: string = null;
  extrasAmount: string = null;
  ivCompanyNames:string[];
  ivCompanyAddresses:string[];
  ivCompanyInfos:string[];
}

class LoadingPlan {
  id: string;
  loadingPlanType: LoadingPlanType;
  code: string;
  createdAt: string;
  category: string;
  factoryNames: string;
  containerTypeInfos: string[];
  totalPCS: number;
  totalAmount: string;
  volumes: string;
  customerId: string;
  customsPackingSet?: CustomsPackingModel[];
}

export class Company {
  name: string;
  type: CompanyType;
}

class CompanyType {
  name: string;
  desc: string;

  constructor(name: string, desc: string) {
    this.name = name;
    this.desc = desc;
  }
}

class LoadingPlanListDetailResponse {
  id: string;
  bookingOrderCode: string;
  customerAbbr: string;
  shippingOrderCode: string;
  billLadingCode: string;
  forwardingCompanies: Company[];
  loadingInfos: LoadingPlan[];
}

export class LoadingPlanType {
  name: string;
  desc: string;
}
